module.exports = __webpack_public_path__ + "static/media/  (61).b5e97323.jpg";